var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecuredocTextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161731",
    "data-name": "Group 161731",
    transform: "translate(-325 -408.795)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_161726",
    "data-name": "Group 161726"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1942",
    "data-name": "Rectangle 1942",
    width: 23,
    height: 23,
    rx: 4,
    transform: "translate(325 408.795)",
    fill: "#cefbf7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2355",
    "data-name": "Path 2355",
    d: "M15.75,6.5V18h-1.5V6.5H10V5H20V6.5Z",
    transform: "translate(321.048 408.795)",
    fill: "#1f2328"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecuredocTextIcon);
export default __webpack_public_path__ + "static/media/securedoc-text-icon.8c0d8111229f2a7d7f8d12521c8a1f80.svg";
export { ForwardRef as ReactComponent };